/** @jsxImportSource @emotion/react */
import { Tag } from "primereact/tag";

// Tag "Extensión" para ítems de facturación cuyo origen es una extensión de
// certificado. Tamaño coherente con el resto de los <Tag> de la app (sin
// fontSize custom), igual que el tag "Extendido".
export default function TagExtension() {
  return (
    <Tag value="Extensión" severity="info" css={{ marginLeft: "0.5em" }} />
  );
}
